var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D4D7DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22434 15.6023L11.2393 5.78137C11.6141 5.04744 12.6659 5.0564 13.0281 5.7966L17.8201 15.5889C18.2272 16.4208 17.3823 17.3113 16.5302 16.9485L12.5325 15.2466C12.287 15.1421 12.01 15.14 11.763 15.2408L7.4927 16.983C6.63431 17.3332 5.80273 16.428 6.22434 15.6023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.9908223c6aaaea8cbc5aa40f79a5503a.svg";
export { ForwardRef as ReactComponent };